var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInnovamatLogoIcon = function SvgInnovamatLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M9.807 4.759a.138.138 0 0 0-.062.261l7.493 3.746a1.38 1.38 0 0 1-.617 2.613H9.807a.138.138 0 0 0-.062.262l7.493 3.746A1.38 1.38 0 0 1 16.621 18H3.381a1.38 1.38 0 0 1 0-2.759h6.813a.138.138 0 0 0 .062-.261l-7.493-3.746A1.38 1.38 0 0 1 3.38 8.62h6.814a.138.138 0 0 0 .062-.262L2.763 4.613A1.38 1.38 0 0 1 3.38 2h9.103a1.38 1.38 0 1 1 0 2.759zM18 3.38a1.38 1.38 0 1 1-2.758 0 1.38 1.38 0 0 1 2.759 0z"
  })));
};
export { SvgInnovamatLogoIcon as ReactComponent };